import { Stack } from '@mui/material'
import { type FC } from 'react'
import { RosterSearchResultsTable } from '../../components/RosterSearchResultsTable'
import { rosterTableColumns } from '../../components/rosterTableColumns'
import { RosterResearchTableToolbar } from '../../components/RosterTableToolbar'

interface RosterSearchProps {}

export const RosterSearch: FC<RosterSearchProps> = () => {
    return (
        <Stack direction="row" height="100%">
            <RosterSearchResultsTable
                storageKey="research-rosters-columns"
                columns={rosterTableColumns}
                toolbar={<RosterResearchTableToolbar />}
                containerProps={{ elevation: 1 }}
            />
        </Stack>
    )
}
